export const WHATSAPP_BASE_URL = 'https://api.whatsapp.com/send';
export const GOOGLE_MAPS_BASE_URL = 'https://maps.google.com';
